<template>
  <div>
    <v-dialog v-model="dialog" width="500" hide-overlay>
      <template v-slot:activator="{on}">
        <v-btn v-if="item == undefined" rounded small dark color="primary" v-on="on">
          <v-icon small left>mdi-plus</v-icon>
          <span>tambah data</span>
        </v-btn>
        <div v-else>
          <v-tooltip top v-if="!isDelete">
            <template v-slot:activator="{on}">
              <v-btn @click="open" small icon color="success" v-on="on">
                <v-icon small dark>edit</v-icon>
              </v-btn>
            </template>
            <span>Edit data</span>
          </v-tooltip>
          <v-tooltip top v-else>
            <template v-slot:activator="{on}">
              <v-btn @click="hapus" small icon color="error" v-on="on">
                <v-icon small dark>delete</v-icon>
              </v-btn>
            </template>
            <span>Hapus data</span>
          </v-tooltip>
        </div>
      </template>
      <v-card class="pa-4">
        <v-card-title>
          <v-spacer></v-spacer>
          <span>Informasi Gejala</span>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-divider class="mt-3 mb-7"></v-divider>
        <v-form ref="form" class="pa-5">
          <v-text-field
            label="Kode Gejala"
            hint="Isikan kode gejala contoh : G-011"
            prepend-icon="lock"
            v-model="data.kode"
            :rules="rKode"
            dense
          ></v-text-field>
          <v-text-field
            label="Nama Gejala"
            hint="Isikan nama gejala"
            prepend-icon="mdi-bacteria"
            v-model="data.nama"
            :rules="rNama"
            dense
          ></v-text-field>
          <v-textarea
            label="Keterangan"
            hint="Isikan keterangan gejala"
            prepend-icon="mdi-text"
            v-model="data.keterangan"
            :rules="rKet"
            dense
          ></v-textarea>
        </v-form>
        <v-row justify="center" align="center" class="mt-4 mb-5">
          <v-tooltip top>
            <template v-slot:activator="{on}">
              <v-btn @click="submit" :loading="loading" small fab color="primary" v-on="on">
                <v-icon small dark>save</v-icon>
              </v-btn>
            </template>
            <span>Simpan data ini.</span>
          </v-tooltip>
          <div class="mx-1"></div>
          <v-tooltip top>
            <template v-slot:activator="{on}">
              <v-btn @click="reset" small fab color="error" v-on="on">
                <v-icon small dark>cancel</v-icon>
              </v-btn>
            </template>
            <span>Reset form.</span>
          </v-tooltip>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import fs from "@/fb";
import Swal from "sweetalert2";
export default {
  props: ["item", "isDelete"],
  data() {
    return {
      rKode: [
        v => !(v.length < 4) || "Kode tidak valid",
        v => !(v.substr(0, 2) != "G-") || "Kode tidak valid"
      ],
      rNama: [v => !(v.length < 5) || "Nama gejala tidak valid"],
      rKet: [v => !(v.length < 10) || "Keterangan tidak valid"],
      dialog: false,
      loading: false,
      data: {
        kode: "",
        nama: "",
        keterangan: ""
      }
    };
  },
  methods: {
    open: function() {
      if (this.item == undefined) {
        this.reset();
      } else {
        this.data = { ...this.item };
        delete this.data.id;
      }
      this.dialog = true;
    },
    reset: function() {
      this.data = {
        kode: "",
        nama: "",
        keterangan: ""
      };
    },
    hapus: async function() {
      try {
        // kode untuk menghapus data
        const y = await Swal.fire({
          icon: "question",
          text: "Anda yakin ingin ingin menghapus data ini ?",
          title: "Delete",
          showCancelButton: true,
          cancelButtonText: "Tidak",
          cancelButtonColor: "teal",
          confirmButtonText: "Ya",
          confirmButtonColor: "red"
        });

        if (y.value) {
          Swal.fire("Info", "Menghapus data ...", "info");
          Swal.showLoading();
          await fs.gejala.doc(this.item.id).delete();
          await Swal.close();
          Swal.fire("Info", "Data tersebut telah dihapus.", "success");
        }
      } catch (e) {
        console.log(e);
      }
    },
    submit: async function() {
      try {
        if (this.$refs.form.validate()) {
          if (this.item != undefined) {
            // edit data

            Swal.fire("Info", "Memperbarui data ...", "info");
            Swal.showLoading();
            await fs.gejala.doc(this.item.id).update({ ...this.data });
            await Swal.close();
            this.reset();
            this.dialog = false;
            Swal.fire("Sukses", "Data gejala berhasil diperbarui.", "success");
          } else {
            // tambah data
            Swal.fire("Info", "Mengecek data ...", "info");
            Swal.showLoading();
            const cek = await fs.gejala
              .where("kode", "==", this.data.kode)
              .get();
            await Swal.close();
            if (cek.size > 0) {
              // data sudah ada
              Swal.fire(
                "Info",
                "Maaf, data gejala dengan kode tersebut sudah ada.",
                "warning"
              );
            } else {
              // input data
              Swal.fire("Info", "Mengentri data baru ...", "info");
              Swal.showLoading();
              await fs.gejala.add({ ...this.data });
              await Swal.close();
              this.reset();
              this.dialog = false;
              Swal.fire(
                "Sukses",
                "Data gejala baru berhasil ditambahkan.",
                "success"
              );
            }
          }
        }
      } catch (e) {
        console.log(e);
      }
    }
  }
};
</script>